import rootApi from '@utils/baseAPI/WrapperApi';

export const apiGetPartnerDailyDeliveries = (params) =>
  rootApi.get('api/partner-daily-deliveries', { params });

export const apiGetPartnerDailyDeliveryBatches = (id) =>
  rootApi.get(`api/partner-daily-deliveries/${id}/batches`);

export const apiRunPartnerDailyDelivery = (targetDate, deliveryType) =>
  rootApi.post('api/partner-daily-deliveries/run', {
    target_date: targetDate,
    delivery_type: deliveryType
  });
